import axios from "axios";

export default {
  mock: false,
  ACCOUNT_LIST_PATH: "/v1/account/list",
  ACCOUNT_LIST_MOCK: [
    {
      id: 1,
      name: "TestNameAcc1",
      userId: 0,
      accountType: "Customer",
      active: true,
      clearingHouseId: 0,
      riskCategoryId: 0,
      autoLiqProfileId: 0,
      marginAccountType: "Hedger",
      legalStatus: "Corporation",
      timestamp: "2019-08-24T14:15:22Z",
      readonly: true,
    },
    {
      id: 2,
      name: "TestNameAcc2",
      userId: 0,
      accountType: "Customer",
      active: true,
      clearingHouseId: 0,
      riskCategoryId: 0,
      autoLiqProfileId: 0,
      marginAccountType: "Hedger",
      legalStatus: "Corporation",
      timestamp: "2019-08-24T14:15:22Z",
      readonly: true,
    },
  ],
  async tradovate_call(token, full_call) {
    let base_call_data = {
      method: "get",
      url: "/",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "https://app.proteryx.com",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Headers":
          "Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Authorization",
      },
      withCredentials: true,
    };
    Object.assign(base_call_data, full_call);
    return await axios(base_call_data);
  },
  default_callback(response) {
    console.log(response);
  },
  default_callback_error(error) {
    console.log(error);
  },
  do_tradovate(token, call_data, callback, callback_error) {
    if (!callback) {
      callback = this.default_callback;
    }
    if (!callback_error) {
      callback_error = this.default_callback_error;
    }
    this.tradovate_call(token, call_data).then(callback).catch(callback_error);
  },
  fetch_account_list(token, server_url, callback, callback_error) {
    if (this.mock) {
      callback({ data: this.ACCOUNT_LIST_MOCK });
      return;
    }
    this.do_tradovate(
      token,
      { url: server_url + this.ACCOUNT_LIST_PATH },
      callback,
      callback_error
    );
  },
  extract_data(data) {
    if (data.s == 200) {
      return data.d;
    } else {
      if (this.debug) console.log("err", data);
      throw new Exception("Cannot access tradovate data.");
    }
  },
};
